/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kostenstellesuffix1Inputs */



/**

* @param {_Field_Kostenstellesuffix1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kostenstellesuffix1 = /** @type {((inputs?: _Field_Kostenstellesuffix1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kostenstellesuffix1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Kostenstelle-Suffix")
});
export { _field_kostenstellesuffix1 as "_field_kostenstelleSuffix" }